import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { StorageKeys } from './shared-module-files/simpo.constant';
import { StaffServiceService } from './master-config-components/micro-apps/staff/service/staff-service.service';
import { EventEmmiterService } from './services/event-emmiter.service';
import { NavMenuService } from './services/navservice/navmenu.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthServiceService } from './services/auth-service.service';
import { SubscriptionService } from './services/subscription.service';
import { Subscription, filter, debounceTime } from 'rxjs';
import { WebsiteMarketingServiceService } from './master-config-components/micro-apps/website-marketing/services/website-marketing-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import path from 'path';
import { MatDialog } from '@angular/material/dialog';
import { CustomFormComponent } from './master-config-components/micro-apps/crm/crm-config/custom-form/custom-form/custom-form.component';
import { CreateQrCouponComponent } from './master-config-components/micro-apps/crm/crm-config/qr-coupon/create-qr-coupon/create-qr-coupon.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private staffService: StaffServiceService,
    private subscriptionService: SubscriptionService,
    private websiteService: WebsiteMarketingServiceService,
    private activate: ActivatedRoute,
    private snackbar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private ngZone: NgZone,
    private eventService: EventEmmiterService,
    private navMenuService: NavMenuService,
  ) {
    this.getScreenSize();
  }

  subscrictinDetailsSubscription?: Subscription;
  private intervalRef: NodeJS.Timeout | null = null;
  screenWidth: number = 0;

  ngOnInit(): void {
  const shouldCleanup = sessionStorage.getItem('pendingUnloadCleanup') === 'true';

  if (shouldCleanup) {
    localStorage.removeItem('isCallingStarted');
    sessionStorage.removeItem('pendingUnloadCleanup');
  }

  window.addEventListener('message', (event: MessageEvent) => {

    if (!event?.data) return;
    if (event.data.type === 'SIMPO_OPEN_CUSTOM_FORM') {
      console.log('Angular received SIMPO_OPEN_CUSTOM_FORM', event.data);

      this.ngZone.run(() => {
        const width = this.screenWidth < 475 ? '100%' : '50%';

        this.dialog.open(CustomFormComponent, {
          width,
          height: '100vh',
          maxWidth: '100vw',
          position: { top: '0', right: '0' },
          disableClose: true,
          data: event.data.payload || { create: true },
        });
      });
    }
    if (event.data.type === 'SIMPO_OPEN_COUPON') {
      console.log('Angular received SIMPO_OPEN_COUPON', event.data);

      this.ngZone.run(() => {
        const width = this.screenWidth < 475 ? '100%' : '50%';

        this.dialog.open(CreateQrCouponComponent, {
          width,
          height: '100vh',
          maxWidth: '100vw',
          position: { top: '0', right: '0' },
          disableClose: true,
          data: event.data.payload || { create: true },
        });
      });
    }
    if (event.data.type === 'nav') {
      const eventPath = event.data.path;
      window.history.pushState({}, '', eventPath);
    }

  });

  this.getStaffPermission();

  // Refresh permissions on every route navigation so role changes propagate immediately
  this.router.events.pipe(
    filter(e => e instanceof NavigationEnd),
    debounceTime(100)
  ).subscribe(() => {
    this.staffService.refreshPermissionsFromServer(this.eventService.silentPermissionRefresh);
  });

  // When permissions actually change, force current route to re-initialize
  // so component-level access flags (createAccess, editAccess, etc.) are re-read
  this.eventService.silentPermissionRefresh.subscribe(() => {
    this.reloadCurrentRoute();
  });

  // When the app-code map is built for the first time (on fresh load / cleared storage),
  // force route re-init so components re-read permissions with the now-resolved codes
  this.navMenuService.codeMapReady$.subscribe(() => {
    this.reloadCurrentRoute();
  });

  this.subscrictinDetailsSubscription =
    this.subscriptionService.getSubscriptionDetails().subscribe();

  localStorage.setItem("REQUEST_FROM", "ECOMMERCE");

  this.activate.queryParams.subscribe((qParam) => {
    const partnerId = qParam["partnerId"];
    if (partnerId) {
      localStorage.setItem("partnerId", partnerId);
    }
  });

  this.intervalRef = setInterval(() => {
    const postData = JSON.parse(window.localStorage.getItem('postData') || '[]');
    if (Array.isArray(postData) && postData.length > 0) {
      const filteredPosts = postData.filter(post => post.count < 10);
      if (filteredPosts.length > 0) {
        this.getpostStatus(filteredPosts);
      }
    }
  }, 60000);

  this.initMidnightLogout();
  this.checkMidnightLogout();

  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.checkMidnightLogout();
    }
  });
}


  // 🔑 Ctrl + R / Ctrl + Shift + R
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {

    const isCallingStarted = localStorage.getItem('isCallingStarted') === 'true';

    if (!isCallingStarted) return;

    // Ctrl + R
    if (event.ctrlKey && !event.shiftKey && event.key.toLowerCase() === 'r') {
      event.preventDefault();
    }

    // Ctrl + Shift + R
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'r') {
      event.preventDefault();
    }

    // F5
    if (event.key === 'F5') {
      event.preventDefault();
    }

    if(event.key.toLocaleLowerCase() == 'alt' && event.key.toLocaleLowerCase() == 'f4'){
      localStorage.clear()
    }
  }

  // Refresh permissions when user comes back to the tab — catches role changes in background
  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      this.staffService.refreshPermissionsFromServer(this.eventService.silentPermissionRefresh);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {

    const isCallingStarted = localStorage.getItem('isCallingStarted') === 'true' ? true : false;

    if (isCallingStarted) {
      sessionStorage.setItem('pendingUnloadCleanup', 'true');
      event.preventDefault();
      event.returnValue = '';
    }
  }


  getNextMidnight(): number {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  initMidnightLogout() {
    const logoutAt = localStorage.getItem('logoutAt');

    if (!logoutAt) {
      localStorage.setItem('logoutAt', this.getNextMidnight().toString());
    }
  }
  checkMidnightLogout() {
    const logoutAt = Number(localStorage.getItem('logoutAt'));

    if (logoutAt && Date.now() >= logoutAt) {
      this.forceLogout();
    }
  }

  forceLogout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['']);
  }



  ngOnDestroy() {
    this.subscrictinDetailsSubscription?.unsubscribe();
    if (this.intervalRef) clearInterval(this.intervalRef);
  }

  title = 'beeos-website-generator';

  getStaffPermission() {
    this.staffService.refreshPermissionsFromServer(this.eventService.silentPermissionRefresh);
  }

  reloadCurrentRoute() {
    // Re-inits just the routed micro-app view (was: bouncing through '/', which
    // tore down and rebuilt the entire admin shell — sidenav included)
    this.eventService.reloadOutlet$.next();
  }

  getpostStatus(postData: { postId: string; count: number }[]) {
    const filteredPosts = postData.filter(post => post.count < 10);
    if (filteredPosts.length === 0) {
      return;
    }
    filteredPosts.forEach((post) => {
      this.websiteService.getPostStatus(post.postId).subscribe(
        (response: any) => {
          if (response.data.socialPostingStatus === "SUCCESS") {
            this.showToast(`Post successfully posted on ${response.data.channelType}! 🎉`, "success");
            this.removePostFromStorage(post.postId);
          } else if (response.data.socialPostingStatus === "FAILED") {
            this.showToast(`Post failed to post. Reason: ${response.data.failedReason || "Unknown"}`, "error");
            this.removePostFromStorage(post.postId);
          } else {
            this.updatePostCount(post.postId);
          }
        },
        (error: any) => { }
      );
    });
  }

  removePostFromStorage(postId: string) {
    const postData = JSON.parse(window.localStorage.getItem('postData') || '[]');
    const updatedData = postData.filter(post => post.postId !== postId);
    window.localStorage.setItem('postData', JSON.stringify(updatedData));
  }

  updatePostCount(postId: string) {
    const postData = JSON.parse(window.localStorage.getItem('postData') || '[]');
    const updatedData = postData.map(post => {
      if (post.postId === postId) {
        return { ...post, count: post.count + 1 };
      }
      return post;
    });
    window.localStorage.setItem('postData', JSON.stringify(updatedData));
  }

  showToast(message: string, type: "success" | "error") {
    this.snackbar.open(message, "close", {
      duration: 6000,
      panelClass: type === "success" ? "success-toast" : "error-toast",
      verticalPosition: "bottom",
      horizontalPosition: "center",
    });
  }
}